var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coach-list"},[_c('f7-row',{attrs:{"no-gap":""}},_vm._l((_vm.coaches),function(coach){return _c('coach-list-item',{key:coach.id,attrs:{"coach":coach},on:{"click":function($event){return _vm.$emit('click', coach.id)},"reviewClick":function($event){return _vm.$emit('reviewClick', coach.id)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }